// TSS vite/04 §"Endpoint paths". baseURL already includes /api/v1.

export const racePaths = {
    list:   ()    => 'admin/races',
    detail: (id)  => `admin/races/${id}`,
};
